import comp from "./UISegmentedControl";
export default comp;
